import { observable, action } from 'mobx';
import { makeObservable } from 'mobx';
import { userState } from '/@/app/states/userState';
import { userFlowState } from '/@/app/states/userFlowState';


export class MeasurementState {
    api=null;
    id = null;   // null for new parameter
    boundParameter = null;  // set for new parameter

    value = null;
    made_at = null;
    warning_bottom_edge = null;
    warning_top_edge = null;

    value_is_computed = false;

    panel_id = null;
    xlsx_id = null;
    profdata_id = null;

    saveStatus;  // "saving", "saved", "error"

    constructor(data, boundParameter, api) {
	this.api=api;
        if (data) {
            // init existing parameter
            this.init(data);
        }
        if (boundParameter) {
            this.boundParameter = boundParameter;
        }

        if (this.id === null) {
            this.saveStatus = "new";
        } else {
            this.saveStatus = "saved";
        }

        makeObservable(this, {
            id: observable,
            // non-editable:
            xlsx_id: observable,
            profdata_id: observable,
            value_is_computed: observable,
            panel_id: observable,
            // editable:
            value: observable,
            made_at: observable,
            warning_bottom_edge: observable,
            warning_top_edge: observable,
            // secondary:
            saveStatus: observable,
            setSaveStatus: action,
            //
            init: action,
            save: action,
            delete: action,
        });
    }

    init(data) {
        this.id = data.id;
        this.xlsx_id = data.xlsx_id;
        this.profdata_id = data.profdata_id;
        this.value_is_computed = data.value_is_computed;
        this.panel_id = data.panel_id;
        // editable:
        this.made_at = data.made_at;
        this.value = data.value;
        this.warning_bottom_edge = data.warning_bottom_edge;
        this.warning_top_edge = data.warning_top_edge;
    }

    setSaveStatus(status) {
        this.saveStatus = status;
    }

    save(data) {
        let url;
        let method;
        if (this.id === null) {
            url = `cabinet/free/${userState.id}/parameters/${this.boundParameter.id}/measurements/`;
            method = "POST";
        } else {
            url = `cabinet/free/${userState.id}/parameters/${this.boundParameter.id}/measurements/${this.id}/`;
            method = "PUT";
        }

        let payload = {
            value: data.value,
        };
        // Date can not be changed for panel-bound measurements,
        // yet it can be added/changed for panel-bound parameters w/o actual panel.
        if (this.id === null || this.panel_id === null) {
            payload.made_at = data.made_at;
        }

        const isNew = this.id === null;

        this.saveStatus = "saving";

        return this.api.request(url, payload, { method: method, })
	.then((data) => {
            this.setSaveStatus("saved");
            this.init(data);
            // thing that possible need decoupling:
            if (isNew) {
                this.boundParameter._addMeasurement(this);
            } else {
                if (this.panel_id && userFlowState.globalPanel.id === this.panel_id) {
                    userFlowState.setCalculateRequired({
                        isRequired: true,
                        postponeForLocation: "/cabinet/free/",
                    });
                }
            }
        }).catch(e => {
            this.setSaveStatus("error");
        });
    }

    delete() {
        if (this.id === null) {
            return;
        }

        this.saveStatus = "saving";

        return this.api.request(
            `cabinet/free/${userState.id}/parameters/${this.boundParameter.id}/measurements/${this.id}/`, {},
            { method: "DELETE" }
        ).then(() => {
            this.setSaveStatus("deleted");
            this.boundParameter._removeMeasurement(this);
        }).catch(e => {
            this.setSaveStatus("error");
        });
    }
}
